import styled from "styled-components";

const Button = styled.button`
  --color: ${props => props.warn ? "#ED5556" : "var(--primary-main-color)"};
  background-color: var(--color);
  color: #fff;
  min-width: 80px;
  padding: 0px 12px;
  height: 36px;
  line-height: 37px;
  border: 0;
  text-align: center;
  border-radius: 25px;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  position: relative;
  box-shadow: 0 0 0 0 #fafafa, 0 0 0 4px rgba(0, 0, 0, 0), 0 0 0 0 var(--color);

  &.outlined {
    background: white;
    border: 1px solid var(--color);
    color: var(--color);
  }
    
  // &:hover,
  // &:focus {
  //   outline: none;
  //   transition: box-shadow linear 0.15s;
  //   box-shadow: 0 0 0 4px #fafafa, 0 0 0 4px rgba(0, 0, 0, 0), 0 0 0 5px var(--primary-main-color);
  // }

  &[disabled] {
    background-color: #a0a0a0;
  }



  &:hover {
    color: #fff;
  }
`;

export const TextButton = styled(Button)`
  background-color: transparent;
  color: #404040;
  min-width: auto;
  box-shadow: none;

  &:focus,
  &:hover {
    box-shadow: none;
    color: var(--primary-main-color);
  }
`;

export default Button;
